import {queryOptions} from '@tanstack/react-query';
import {unwrap} from 'framework';
import type {ScheduleDependencies} from '../dependencies';
import {keys} from './keys';

export type GetActiveScheduleWorkoutQueryDependencies = Pick<ScheduleDependencies, 'controllers'>;

export const getActiveScheduleWorkoutQuery = ({
  controllers,
}: GetActiveScheduleWorkoutQueryDependencies) =>
  queryOptions({
    queryKey: keys.activeWorkout(),
    queryFn: () => controllers.scheduleController.getActive().then(unwrap),
  });
